import type { RootState } from 'store'
import type { GetterTree } from 'vuex'
import type { ProjectState } from './types'

export const getters: GetterTree<ProjectState, RootState> = {
  projects: (state: ProjectState) => state.projects,
  total: (state: ProjectState) => state.projects && state.projects.length,
  selectedProjectIds: (state: ProjectState) => state.selectedProjectIds,
}
